import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.m.scss';

const propTypes = {
  finishBtn: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  skipBtn: PropTypes.any,
  handleSubmit: PropTypes.func,
  padded: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  setStep: PropTypes.func,
  step: PropTypes.number,
};

const Footer = ({ finishBtn: FinishButton, skipBtn, handleSubmit, padded, isSubmitting, isValid, setStep, step }) => {
  const isFirstStep = step === 0;

  return (
    <div className={cn(styles.stepButtons, { 'mt-4': padded })}>
      {!isFirstStep && (
        <button type="button" className="btn btn-outline-primary" onClick={() => setStep(step - 1)}>
          Back
        </button>
      )}
      <div className="flex-grow-1" />
      {skipBtn}
      {FinishButton ? (
        <FinishButton />
      ) : (
        <button type="submit" disabled={!isValid || isSubmitting} onClick={handleSubmit} className="btn btn-primary">
          Next
        </button>
      )}
    </div>
  );
};

Footer.propTypes = propTypes;

export default Footer;
